import { render, staticRenderFns } from "./WDVsaLeadsNotes.vue?vue&type=template&id=28b81164&"
import script from "./WDVsaLeadsNotes.vue?vue&type=script&lang=js&"
export * from "./WDVsaLeadsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports